export default {
	title: 'Land Consumption Rate/Population Growth Rate',
	configuration: {
		attributes: ['3483d7cc-1cde-4a98-b09a-7dddc0ee16f4'],
		type: 'ratesRatio',
	},
};
